import * as fb from './facebookEvents';
import * as product from './productHelpers';
import * as location from './locationHelpers';

const addToCart = () => {
  const addToCartForms = [...document.querySelectorAll('[v65js=addToCart]')];
  if (!addToCartForms.length) {
    return false;
  }

  // Can't override Vin65 event without wrapping in DOMContentLoaded event
  return document.addEventListener('DOMContentLoaded', () => {
    addToCartForms.forEach(form => form.addEventListener('submit', handleAddToCart, false));
  });
};

const handleAddToCart = (event) => {
  const inputs = event.target.getElementsByTagName('input');
  const customData = {
    contents: [{
      id: inputs.productSKU.value,
      quantity: parseInt(inputs.Quantity.value, 10),
      item_price: product.getPrice(),
    }],
  };

  const pixelData = fb.getPixelData(customData);

  fb.addToCart(pixelData);
};

const productSearch = () => {
  if (location.isSearchResults) {
    const params = new URLSearchParams(document.location.search.substring(1));
    const customData = {
      search_string: params.get('searchText'),
    };
    fb.search(Object.assign(fb.defaultPixelData, customData));
  }

  const productSearchForms = [...document.querySelectorAll('input[value*="products.search"]')];
  if (!productSearchForms.length) {
    return false;
  }

  return productSearchForms.forEach(form => form.parentElement.addEventListener('submit', handleProductSearch, false));
};

const handleProductSearch = (event) => {
  const inputs = event.target.getElementsByTagName('input');
  const customData = {
    search_string: inputs.searchText && inputs.searchText.value,
  };

  fb.search(Object.assign(fb.defaultPixelData, customData));
};

const trackReOrders = () => {
  const reOrderLinks = [...document.querySelectorAll('a[href*="/index.cfm?method=cartV2.oneClickDuplicate"]')];

  if (!reOrderLinks.length) {
    return false;
  }

  return reOrderLinks.forEach((link) => {
    link.addEventListener('click', handleReOrder, false);
  });
};

const handleReOrder = (event) => {
  const href = event.target.href || event.target.parentElement.href;
  const orderId = href && href.split('orderID=')[1];

  return product.getOrderDetails(orderId).then((orderItems) => {
    const pixelData = Object.assign(fb.defaultPixelData, orderItems);
    fb.addToCart(pixelData);
  });
};

const initiateCheckout = () => {
  if (!location.isCheckout) { return false; }

  const customData = {
    num_items: 0,
  };

  const quantities = [...document.getElementsByClassName('v65-quantity')];
  customData.num_items = quantities.reduce((total, qty) => total + parseInt(qty.textContent.split('Qty: ')[1], 10), 0);

  const pixelData = Object.assign(fb.defaultPixelData, customData);

  return fb.initiateCheckout(pixelData);
};

const paymentComplete = () => {
  if (!location.isReceipt || !location.cameFromCheckout) { return false; }

  return product.getOrderDetails(window.orderID).then((orderItems) => {
    fb.purchase(Object.assign(fb.defaultPixelData, orderItems));
  });
};

const clubSignupComplete = () => {
  if (!location.isClubSignupReceipt || !location.cameFromClubSignup) { return false; }

  const pixelData = fb.defaultPixelData;
  delete pixelData.content_type;

  return fb.completeRegistration(pixelData);
};

export {
  addToCart,
  initiateCheckout,
  paymentComplete,
  productSearch,
  trackReOrders,
  clubSignupComplete,
};

// const savePaymentDetails = () => {
//   const submitButton = document.querySelector('.v65-billingInformation button');
//   if (!submitButton) {
//     return false;
//   }
//
//   return submitButton.addEventListener('click', handleSavePaymentDetails, false);
// };
//
// const handleSavePaymentDetails = () => {
//   const saveCardOnFile = document.getElementById('isSaveCardOnFile').checked;
//   if (saveCardOnFile) {
//     fb.addPaymentInfo();
//   }
// };

// const joinClubSubmit = () => {
//   const joinClubLinks = [...document.querySelectorAll('a[href*="/index.cfm?method=clubsV2SignUp"]')];
//   if (!joinClubLinks.length) {
//     return false;
//   }
//
//   return document.addEventListener('DOMContentLoaded', () => {
//     joinClubLinks.forEach((link) => {
//       link.addEventListener('click', handleClubSignup, false);
//     });
//   });
// }
//
// const handleClubSignup = (event) => {
//   const inputs = event.target.getElementsByTagName('input');
//   const quantity = parseInt(inputs['Quantity'].value);
//   const id = inputs['productSKU'].value
//   const item_price = getPrice();
//
//   {
//     contents: [{id, quantity, item_price}]
//   }
//   addToCart();
// };
